var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"automation-action-settings"},[_c('journey-tree',{attrs:{"height":"100%"},on:{"select":_vm.selectNode},scopedSlots:_vm._u([{key:"actions",fn:function({ node: childNode }){return [(!Object.values(childNode.children).length)?_c('span',{staticClass:"icon"},[_c('div',{staticClass:"far fa",class:_vm.selectedId === childNode.id
                            ? 'fa-check-square'
                            : 'fa-square-o'})]):_vm._e()]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }